/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "4.1.1";
